import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getClientsCount = reatomAsync(
  async (ctx, { userId }: { userId: string }) => {
    return API.poizonClientApi
      .clientControllerGetClientsCountByUserId(userId)
      .then((response) => response.data);
  },
  "getClientsCountRequest",
).pipe(withDataAtom(0), withIsLoadingAtom());
